module.exports = __webpack_public_path__ + "static/img/p1.45559c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/p1.png
// module id = PxU+
// module chunks = 0